import axios from 'axios';
//import store from '../store';

const intance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        "Content-type": "application/json",
        'Accept' : 'application/json',
    }
});


intance.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error)
);

export default intance;
